// The badges-4 goal endpoints: the next badges within reach (GET /me/next) and the
// nudges the reveal host shows once (POST /me/nudges/seen). Injected into the
// shared API next to badgesApi, with the same base URL and the same Badges tag.
import { baseApi } from "../../../services/rtkApi/baseApi";
import type { MarkBadgeNudgesSeenRequest, MarkBadgeNudgesSeenResponse, MyNextBadgesResponse } from "../types";

// relative to API_BASE_URL, which already ends in /api
export const goalsPaths = {
  next: "/badges/me/next",
  nudgesSeen: "/badges/me/nudges/seen",
} as const;

// The goals also answer to their own id, so a shown nudge (a goal moved) can
// refresh them without refetching every other badge query on screen.
const NEXT_TAG = { type: "Badges" as const, id: "NEXT" };

export const goalsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyNextBadges: builder.query<MyNextBadgesResponse, void>({
      query: () => goalsPaths.next,
      providesTags: ["Badges", NEXT_TAG],
    }),
    markBadgeNudgesSeen: builder.mutation<MarkBadgeNudgesSeenResponse, MarkBadgeNudgesSeenRequest>({
      query: (body) => ({ url: goalsPaths.nudgesSeen, method: "POST", body }),
      invalidatesTags: [NEXT_TAG],
    }),
  }),
  overrideExisting: false,
});

export const { useGetMyNextBadgesQuery, useMarkBadgeNudgesSeenMutation } = goalsApi;
